import React, { Fragment, useContext, useEffect } from "react";
import { Grid, Typography, Breadcrumbs, Link } from "@material-ui/core";

import useSWR from "swr";

// Contexts
import DomainContext from "../../../context/domains/DomainContext";

// Components
import DomainAdd from "./DomainAdd";
import DomainList from "./DomainList";
import fetcher from "../../../fetcher";

const Domain = () => {
  const { data: PROJECTS } = useSWR("/api/project/");
  const { data: DOMAINS, mutate: MUTATE_DOMAINS } = useSWR(`${process.env.REACT_APP_SERVER_URL}api/domain`, fetcher);

  const { setProjects, setDomains, search_domain, filterDomains, editDomain } =
    useContext(DomainContext);

  useEffect(() => {
    if (PROJECTS) setProjects(PROJECTS);

    if (DOMAINS) {
      setDomains(DOMAINS.data);
      if (search_domain) filterDomains(search_domain);
    }
  }, [PROJECTS, DOMAINS]);

  const handleEdit = (index, domain) => {
    editDomain(index, domain);
  };

  const handleUpdate = () => {
    MUTATE_DOMAINS();
    handleEdit(null, null);
  };

  return (
    <Fragment>
      <Grid container spacing={1}>
        {" "}
        {/* Breadcrumbs */}{" "}
        <Grid container justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Domains </Typography>{" "}
          </Grid>
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit"> Domains </Link>{" "}
            </Breadcrumbs>{" "}
          </Grid>{" "}
        </Grid>
        <Grid
          container
          direction="column"
          spacing={2}
          style={{
            marginTop: 5,
          }}
        >
          <DomainAdd handleUpdate={handleUpdate} />{" "}
          <DomainList handleEdit={handleEdit} handleUpdate={handleUpdate} />{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Fragment>
  );
};

export default Domain;
